import {ShellFooter} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'

export const RefraPlannerFooter: React.FC = () => {
  const {t} = useTranslation()

  return <ShellFooter label={t('footer.poweredBy')} />
}
